<template>
  <EhouseDoubleCalculating />
</template>

<script>
import EhouseDoubleCalculating from "@/components/Calculatings/EhouseDoubleCalculating/index.vue";
export default {
  components: {
    EhouseDoubleCalculating,
  },
};
</script>

<style></style>
